<template>
  <section class="section assinatura-page">
    <div class="content content-top">
      <div v-if="signatures.length > 0" class="my-subscriptions-section">
        <h2 class="my-subscriptions-title">Minhas Assinaturas</h2>
        <div v-for="item in signatures" :key="item.id" class="my-subscription-card">
          <div class="subscription-info">
            <div class="subscription-plan-card">
              <h3 class="subscription-plan-name">{{ item.name }}</h3>
              <p v-if="item.desc" class="subscription-plan-desc">{{ item.desc }}</p>
              <div v-if="!isSignatureWaitingPayment(item) && shouldApplyRenewalDiscount(item)" class="second-sub-notice subscription-notice">
                <strong>Renovação com {{ getDiscountPercentForItem(item) }}% de desconto</strong>
                <span v-if="getRenewalAlignedNextDate(item)">
                  O vencimento será o mesmo do {{ fullReferenceLabel(getProductTypeForSignature(item)) }} ({{ getRenewalAlignedNextDate(item) }}).
                </span>
              </div>
              <div v-if="item.price != null" class="subscription-plan-price">
                <span v-if="!isSignatureWaitingPayment(item) && shouldApplyRenewalDiscount(item)" class="price-original">R$ {{ formatPrice(getRenewalOriginalPriceBrl(item)) }}</span>
                R$ {{ formatPrice(isSignatureWaitingPayment(item) ? (item.price || getRenewalOriginalPriceBrl(item)) : getRenewalPriceBrl(item)) }}
              </div>
              <div class="subscription-badge">{{ isSignatureEffectivelyActive(item) ? 'Assinatura Atual' : 'Assinatura' }}</div>
            </div>
            <div class="subscription-status-card">
              <div v-if="isSignatureWaitingPayment(item)" class="status-block status-waiting">
                <span class="status-label">Aguardando Pagamento</span>
                <button @click="callPayment(item)" class="button-save btn-payment"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
                <div v-if="error" class="hint">{{ error[0] }}</div>
              </div>
              <div v-else-if="isSignatureRenewable(item)" class="status-block status-expired">
                <span class="status-label">Assinatura Vencida</span>
                <div class="status-detail">
                  <span class="status-detail-label">Vencimento</span>
                  <span class="status-detail-value">{{ item.nextDate }}</span>
                </div>
                <div v-if="shouldApplyRenewalDiscount(item) && getRenewalAlignedNextDate(item)" class="status-detail">
                  <span class="status-detail-label">Novo vencimento</span>
                  <span class="status-detail-value">{{ getRenewalAlignedNextDate(item) }}</span>
                </div>
                <div v-if="shouldApplyRenewalDiscount(item)" class="renewal-discount-hint">
                  Renovação com {{ getDiscountPercentForItem(item) }}% de desconto
                  — R$ {{ formatPrice(getRenewalPriceBrl(item)) }}
                </div>
                <button @click="callPayment(item)" class="button-save btn-payment"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
                <div v-if="error" class="hint">{{ error[0] }}</div>
              </div>
              <div v-else-if="isSignatureEffectivelyActive(item)" class="status-block status-active">
                <span class="status-label">Sua assinatura está Ativa</span>
                <div class="status-detail">
                  <span class="status-detail-label">Vencimento</span>
                  <span class="status-detail-value">{{ item.nextDate }}</span>
                </div>
                <div v-if="item.valid === 1 && shouldApplyRenewalDiscount(item) && getRenewalAlignedNextDate(item)" class="status-detail">
                  <span class="status-detail-label">Novo vencimento</span>
                  <span class="status-detail-value">{{ getRenewalAlignedNextDate(item) }}</span>
                </div>
                <div v-if="item.valid === 1 && shouldApplyRenewalDiscount(item)" class="renewal-discount-hint">
                  Renovação com {{ getDiscountPercentForItem(item) }}% de desconto
                  — R$ {{ formatPrice(getRenewalPriceBrl(item)) }}
                </div>
                <button v-if="item.valid === 1" @click="callPayment(item)" class="button-save btn-payment"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
                <div v-if="item.valid === 1 && error" class="hint">{{ error[0] }}</div>
              </div>
              <div class="subscription-contact">
                <p class="contact-text">Para informações, ser incluído no grupo privado, pagamentos, alteração de assinatura, entre em contato abaixo</p>
                <img class="telegram-icon" src="/img/telegram.png" @click="gotoTelegram()" alt="Telegram Suporte" title="Contato via Telegram">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="product" class="main-text" style="margin-top: 30px;">Assinatura Escolhida</div>
      <div v-if="product" class="content" style="margin-top: 20px;">
        <div class="list_plans">
          <div class="show_plan">
            <div class="card_event">
              <div class="show-name">{{ product.name }}</div>
              <div class="show-date">{{ product.desc }}</div>
              <div v-if="product.secondSubscription" class="second-sub-notice">
                <strong v-if="product.secondSubscriptionDiscount > 0">2ª assinatura com {{ product.secondSubscriptionDiscount }}% de desconto</strong>
                <strong v-else>2ª assinatura</strong>
                <span>O vencimento será o mesmo do {{ fullReferenceLabel(product.productType) }}{{ product.alignedNextDate ? ` (${product.alignedNextDate})` : '' }}.</span>
              </div>
              <div v-if="product.secondSubscription && product.originalPrice != null" class="plan_discount">R$ {{ product.originalPrice.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div v-else-if="product.discount && product.type === 'percent'" class="plan_discount">R$ {{ (product.price + (product.discount * product.price / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div v-else-if="product.discount && product.type === 'fixed'" class="plan_discount">R$ {{ (product.price + product.discount).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div class="show-date">R$ {{ product.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div v-if="product.expiration" class="show-date">Válido até {{ product.expiration }}</div>
            </div>
          </div>
          <div class="finish_plan">
            <div class="show-name">
              Assim que o pagamento for finalizado, sua assinatura é ativada automaticamente.
            </div>
            <!-- <div class="actions btn-buyplan" @click="finishPlan"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i>SOLICITAR ASSINATURA</div> -->
            <div class="actions">
              <button @click="callPayment(null)" style="font-size:14px;" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
              <div v-if="error" class="hint">{{ error[0] }}</div>
              <button @click="product = null" class="button-save" style="font-size: 16px;margin-top: 60px;background-image: linear-gradient(to bottom right, #3d8a46, #3d8a46);"><i class="fas fa-check"></i><span>Escolher outra assinatura</span></button>
              <!-- <div id="wallet_container"></div>
              <div id="paymentBrick_container"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="plans-section-assinatura">
      <div class="plans-container">
        <div class="main-text plans-title">Assinaturas mensais do Swiss Money</div>

        <template v-if="activeProducts.length > 0">
          <div class="plans-platform-tabs">
            <button
              v-for="(prod, idx) in activeProducts"
              :key="`platform-${prod.id}-${prod.platform}`"
              type="button"
              class="platform-tab"
              :class="{ active: selectedPlatformIndex === idx }"
              @click.stop="selectPlatform(idx)"
            >
              {{ platformLabel(prod.platform) || prod.name }}
            </button>
          </div>

          <div :key="`plans-${selectedPlatformIndex}-${selectedProduct && selectedProduct.id}`" class="plans-content">
          <div class="plans-periods">
            <div
              v-for="(per, pIdx) in (selectedProduct && selectedProduct.periods) || []"
              :key="per.id"
              class="period-item"
              :class="{ active: selectedPeriodIndex === pIdx }"
              @click="selectedPeriodIndex = pIdx"
            >
              <div class="period-item-name">{{ per.periodName || per.period_name }}</div>
              <div class="period-item-prices">
                <span v-if="(!showUsd || (showUsd && !(per.priceUsd != null && per.priceUsd > 0))) && per.price != null && per.price > 0">
                  <template v-if="per.promotion && (per.type === 'percent' || per.type === 'fixed')">
                    <span class="period-price-old">R$ {{ formatPrice(per.price) }}</span>
                    <span class="period-price-promo">R$ {{ formatPrice(promotionPrice(per)) }}</span>
                  </template>
                  <template v-else>
                    <span class="period-price">R$ {{ formatPrice(per.price) }}</span>
                  </template>
                </span>
                <span v-if="showUsd && per.priceUsd != null && per.priceUsd > 0" class="period-usd">
                  <template v-if="per.promotion && (per.type === 'percent' || per.type === 'fixed')">
                    <span class="period-price-old">US$ {{ formatPriceUsd(per.priceUsd) }}</span>
                    <span class="period-price-promo">US$ {{ formatPriceUsd(promotionPriceUsd(per)) }}</span>
                  </template>
                  <template v-else>
                    <span class="period-price">US$ {{ formatPriceUsd(per.priceUsd) }}</span>
                  </template>
                </span>
              </div>
              <div v-if="per.promotion && per.expiration" class="period-item-validity">Válido até {{ per.expiration }}</div>
              <div v-if="getSecondSubscriptionDiscount(per) > 0 && shouldApplySecondSubscriptionDiscount(per.id)" class="period-item-second-sub">
                2ª assinatura: {{ getSecondSubscriptionDiscount(per) }}% de desconto
                <span v-if="(!showUsd || !(per.priceUsd != null && per.priceUsd > 0)) && per.price != null && per.price > 0">
                  (R$ {{ formatPrice(secondSubscriptionPriceBrl(per)) }})
                </span>
                <span v-else-if="showUsd && per.priceUsd != null && per.priceUsd > 0">
                  (US$ {{ formatPriceUsd(secondSubscriptionPriceUsd(per)) }})
                </span>
              </div>
            </div>
          </div>

          <div class="plans-detail">
            <div v-if="selectedProduct && selectedPeriod" class="plan-detail-card">
              <div class="plan-detail-header">
                <h3 class="plan-detail-platform">{{ platformLabel(selectedProduct.platform) || selectedProduct.name }}</h3>
                <img v-if="platformLogo(selectedProduct.platform)" :src="platformLogo(selectedProduct.platform)" :alt="platformLabel(selectedProduct.platform)" class="plan-detail-logo" />
              </div>
              <p v-if="selectedProduct.desc" class="plan-detail-desc">{{ selectedProduct.desc }}</p>
              <p class="plan-detail-period">{{ selectedPeriod.periodName || selectedPeriod.period_name }}</p>
              <p class="plan-detail-desc">{{ selectedPeriod.description }}</p>
              <div v-if="selectedProductRequiresIndicator && !hasActiveIndicatorSubscription" class="second-sub-notice plan-detail-notice indicator-required-notice">
                <strong>Assinatura de indicador necessária</strong>
                <span>Para assinar o Bot Yan ou o Dashboard, você precisa ter uma assinatura ativa de indicador.</span>
              </div>
              <div v-if="selectedPeriod && isSecondSubscription(selectedPeriod.id)" class="second-sub-notice plan-detail-notice">
                <strong v-if="secondSubscriptionApplies">
                  2ª assinatura ({{ productTypeLabel(getProductTypeForProduto(selectedProduct)) }}) com {{ getSecondSubscriptionDiscount(selectedPeriod) }}% de desconto
                </strong>
                <strong v-else>
                  2ª assinatura ({{ productTypeLabel(getProductTypeForProduto(selectedProduct)) }})
                </strong>
                <span v-if="secondSubscriptionApplies">
                  O vencimento será o mesmo do {{ fullReferenceLabel(getProductTypeForProduto(selectedProduct)) }}{{ referenceActiveSignature && referenceActiveSignature.nextDate ? ` (${referenceActiveSignature.nextDate})` : '' }}.
                </span>
                <span v-else>
                  A validade será a mesma da sua assinatura ativa.
                </span>
              </div>
              <div class="plan-detail-price">
                <template v-if="(!showUsd || (showUsd && !(selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0))) && selectedPeriod.price != null && selectedPeriod.price > 0">
                  <span v-if="secondSubscriptionApplies" class="price-original">R$ {{ formatPrice(checkoutOriginalPriceBrl) }}</span>
                  <span v-else-if="selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed')" class="price-original">R$ {{ formatPrice(selectedPeriod.price) }}</span>
                  <span class="price-amount">R$ {{ formatPrice(checkoutPriceBrl) }}</span>
                </template>
                <template v-if="showUsd && selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0">
                  <span v-if="secondSubscriptionApplies" class="price-original">US$ {{ formatPriceUsd(checkoutOriginalPriceUsd) }}</span>
                  <span v-else-if="selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed')" class="price-original">US$ {{ formatPriceUsd(selectedPeriod.priceUsd) }}</span>
                  <span class="price-amount">US$ {{ formatPriceUsd(checkoutPriceUsd) }}</span>
                </template>
              </div>
              <!-- Intencional: não exibir mensagens quando o desconto não se aplica -->
              <p v-if="selectedPeriod.promotion && selectedPeriod.expiration" class="plan-detail-validity">Válido até {{ selectedPeriod.expiration }}</p>
              <ul class="plan-detail-features">
                <li>✓ Acesso conforme período</li>
                <li>✓ Indicadores Swiss</li>
                <li>✓ Suporte Premium</li>
              </ul>
              <button
                type="button"
                class="plan-button plan-detail-button"
                :disabled="!canPurchaseSelectedProduct"
                @click="confirmarAssinatura"
              >
                Realizar Pagamento
              </button>
            </div>
            <div v-else class="plan-detail-empty">
              <p>Selecione um período ao lado.</p>
            </div>
          </div>
        </div>
      </template>
      </div>
    </div>
    <!-- <UserPix v-if="selectedWaiting" :ticket="selectedWaiting" :closeModal="function () { selectedWaiting = null }"/> -->
    <Payment v-if="selectedWaiting" :product="product" :signId="signId ? signId : null" :closeModal="function () {
      selectedWaiting = null
      product = null
      signId = null
      getData()
    }"/>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getGrouped } from '../../admin/api/product'
import { getGeo } from '../../main/api/geo'
import { create, payment, get } from '../api/signature'
import { getParameters as getSystemParameters } from '../api/systemParameter'
import Payment from './Payment.vue'

export default {
  name: 'assinatura',
  components: { Payment },
  props: ['type'],
  data () {
    return {
      error: [],
      loading: false,
      product: null,
      selectedWaiting: null,
      products: [],
      signatures: [],
      signId: null,
      selectedPlatformIndex: 0,
      selectedPeriodIndex: 0,
      userCountry: null,
      indicatorFullDiscountDays: 25
    }
  },
  computed: {
    ...mapState(['user']),
    activeProducts () {
      return (this.products || []).filter(p => p.active)
    },
    selectedProduct () {
      if (!this.activeProducts.length) return null
      const i = Math.min(this.selectedPlatformIndex, this.activeProducts.length - 1)
      return this.activeProducts[i]
    },
    selectedPeriod () {
      const prod = this.selectedProduct
      if (!prod || !prod.periods || !prod.periods.length) return null
      const i = Math.min(this.selectedPeriodIndex, prod.periods.length - 1)
      return prod.periods[i]
    },
    showUsd () {
      return this.userCountry && this.userCountry !== 'BR'
    },
    activeSignatures () {
      return (this.signatures || []).filter(s => this.isSignatureEffectivelyActive(s))
    },
    hasActiveIndicatorSubscription () {
      return this.activeSignatures.some(s => this.getProductTypeForSignature(s) === 'indicator')
    },
    selectedProductRequiresIndicator () {
      const type = this.getProductTypeForProduto(this.selectedProduct)
      return type === 'bot' || type === 'dash'
    },
    canPurchaseSelectedProduct () {
      return !this.selectedProductRequiresIndicator || this.hasActiveIndicatorSubscription
    },
    referenceActiveSignature () {
      return this.getReferenceSignatureForSecondSubscription(
        this.selectedPeriod && this.selectedPeriod.id
      )
    },
    secondSubscriptionApplies () {
      if (!this.selectedPeriod) return false
      return this.shouldApplySecondSubscriptionDiscount(this.selectedPeriod.id)
    },
    selectedSecondSubscriptionDiscount () {
      return this.getSecondSubscriptionDiscount(this.selectedPeriod)
    },
    checkoutOriginalPriceBrl () {
      return this.periodPriceBrl(this.selectedPeriod)
    },
    checkoutOriginalPriceUsd () {
      return this.periodPriceUsd(this.selectedPeriod)
    },
    checkoutPriceBrl () {
      const base = this.checkoutOriginalPriceBrl
      if (this.secondSubscriptionApplies) {
        return this.applySecondSubscriptionDiscount(base, this.selectedSecondSubscriptionDiscount)
      }
      return base
    },
    checkoutPriceUsd () {
      const base = this.checkoutOriginalPriceUsd
      if (this.secondSubscriptionApplies) {
        return this.applySecondSubscriptionDiscount(base, this.selectedSecondSubscriptionDiscount)
      }
      return base
    }
  },
  async mounted () {
    if (!this.user) {
      this.$router.push('/')
      this.$store.commit('redirect', '/usuario')
      this.$store.commit('showLogin', true)
      return false
    }
    this.getData()
    getGeo().then(r => { this.userCountry = r.country }).catch(() => {})
    document.body.style.backgroundColor = '#0b0e11'
  },
  watch: {
    activeProducts (products) {
      if (!products.length) {
        this.selectedPlatformIndex = 0
        this.selectedPeriodIndex = 0
        return
      }
      if (this.selectedPlatformIndex >= products.length) {
        this.selectedPlatformIndex = 0
        this.selectedPeriodIndex = 0
      }
    }
  },
  methods: {
    selectPlatform (idx) {
      if (idx < 0 || idx >= this.activeProducts.length) return
      this.selectedPlatformIndex = idx
      this.selectedPeriodIndex = 0
    },
    parseNextDate (nextDateStr) {
      if (!nextDateStr) return null
      if (nextDateStr instanceof Date && !isNaN(nextDateStr.getTime())) {
        return new Date(nextDateStr.getFullYear(), nextDateStr.getMonth(), nextDateStr.getDate())
      }
      const raw = String(nextDateStr).trim()
      const br = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
      if (br) return new Date(Number(br[3]), Number(br[2]) - 1, Number(br[1]))
      const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
      if (iso) return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]))
      const parsed = new Date(raw)
      if (!isNaN(parsed.getTime())) {
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
      }
      return null
    },
    signatureNextDate (item) {
      if (!item) return null
      return item.nextDate || item.next_date || null
    },
    daysUntilExpiration (nextDateStr) {
      const expDay = this.parseNextDate(nextDateStr)
      if (!expDay) return null
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      expDay.setHours(0, 0, 0, 0)
      return Math.ceil((expDay - today) / (1000 * 60 * 60 * 24))
    },
    getDiscountMinDays () {
      const minDays = Number(this.indicatorFullDiscountDays)
      return Number.isNaN(minDays) || minDays < 0 ? 25 : minDays
    },
    isMainSubscriptionDiscountEligible (periodoId) {
      const ref = this.getReferenceSignatureForSecondSubscription(periodoId)
      if (!ref || !this.signatureNextDate(ref)) return false
      const daysLeft = this.daysUntilExpiration(this.signatureNextDate(ref))
      return daysLeft != null && daysLeft >= this.getDiscountMinDays()
    },
    getRenewalReferenceSignature (item) {
      if (item && item.renewalReferenceDate) {
        return { nextDate: item.renewalReferenceDate }
      }
      if (!item) return null
      const type = this.getProductTypeForSignature(item)
      return this.getFullPriceReferenceByType(type, item.id, null)
    },
    getRenewalAlignedNextDate (item) {
      if (item && item.renewalReferenceDate) return item.renewalReferenceDate
      const ref = this.getRenewalReferenceSignature(item)
      return this.signatureNextDate(ref)
    },
    fullReferenceLabel (type) {
      if (type === 'bot') return 'bot cheio'
      if (type === 'dash') return 'dash cheio'
      return 'indicador cheio'
    },
    shouldApplyRenewalDiscount (item) {
      if (!item) return false
      if (item.renewalDiscountApplies === true) return true
      if (item.renewalDiscountApplies === false) return false
      if (item.product == null) return false
      const ref = this.getRenewalReferenceSignature(item)
      if (!ref || !this.signatureNextDate(ref)) return false
      const daysLeft = this.daysUntilExpiration(this.signatureNextDate(ref))
      if (daysLeft == null || daysLeft < this.getDiscountMinDays()) return false
      return this.getDiscountPercentForItem(item) > 0
    },
    getProductTypeForProduto (prod) {
      if (!prod) return null
      const type = prod.productType || prod.product_type
      if (type === 'indicator' || type === 'bot' || type === 'dash') return type
      if (prod.platform && String(prod.platform).endsWith('_yan')) return 'bot'
      if (prod.platform === 'dashboard') return 'dash'
      return 'indicator'
    },
    getProductTypeForPeriodoId (periodoId) {
      const per = this.findPeriodById(periodoId)
      if (!per) return null
      const prod = (this.products || []).find(p =>
        (p.periods || []).some(x => x === per || Number(x.id) === Number(per.id))
      )
      return this.getProductTypeForProduto(prod)
    },
    getProductTypeForSignature (signature) {
      if (!signature) return null
      const type = signature.productType || signature.product_type
      if (type === 'indicator' || type === 'bot' || type === 'dash') return type
      if (signature.platform && String(signature.platform).endsWith('_yan')) return 'bot'
      if (signature.platform === 'dashboard') return 'dash'
      const fromProduct = this.getProductTypeForPeriodoId(signature.product)
      if (fromProduct) return fromProduct
      return 'indicator'
    },
    signatureRequiresIndicator (signature) {
      const type = this.getProductTypeForSignature(signature)
      return type === 'bot' || type === 'dash'
    },
    productTypeRequiresIndicator (type) {
      return type === 'bot' || type === 'dash'
    },
    showIndicatorRequirementError () {
      const message = 'Para assinar o Bot Yan ou o Dashboard, você precisa ter uma assinatura ativa de indicador.'
      this.error = [message]
      this.$message.error(message, { duration: 5000 })
    },
    isFullPriceSignature (signature) {
      const paid = Number(signature && signature.price)
      if (!paid) return true
      const per = this.getSignaturePeriod(signature)
      if (!per) return true
      const catalog = this.periodPriceBrl(per)
      if (!catalog) return true
      const pct = this.getSecondSubscriptionDiscount(per)
      if (pct > 0) {
        const secondPrice = this.applySecondSubscriptionDiscount(catalog, pct)
        if (Math.abs(paid - secondPrice) <= 1 && Math.abs(paid - catalog) > 1) return false
      }
      return paid >= catalog - Math.max(1, catalog * 0.02)
    },
    getFullPriceReferenceByType (targetType, excludeSignatureId = null, excludeProductId = null) {
      if (!targetType) return null
      const minDays = this.getDiscountMinDays()
      const candidates = (this.activeSignatures || []).filter(s => {
        if (excludeSignatureId != null && Number(s.id) === Number(excludeSignatureId)) return false
        if (excludeProductId != null && Number(s.product) === Number(excludeProductId)) return false
        const nextDate = this.signatureNextDate(s)
        if (!nextDate || this.isSignatureExpired(s)) return false
        if (this.getProductTypeForSignature(s) !== targetType) return false
        if (!this.isFullPriceSignature(s)) return false
        const daysLeft = this.daysUntilExpiration(nextDate)
        return daysLeft != null && daysLeft >= minDays
      })
      if (!candidates.length) return null
      return candidates.reduce((latest, current) => {
        const latestDate = this.parseNextDate(this.signatureNextDate(latest))
        const currentDate = this.parseNextDate(this.signatureNextDate(current))
        if (!latestDate) return current
        if (!currentDate) return latest
        return currentDate > latestDate ? current : latest
      })
    },
    getReferenceSignatureForSecondSubscription (periodoId, excludeSignatureId = null) {
      const fromPeriod = this.getProductTypeForPeriodoId(periodoId)
      const fromSignature = (this.signatures || []).find(s => Number(s.product) === Number(periodoId))
      const targetType = fromPeriod || this.getProductTypeForSignature(fromSignature) || this.getProductTypeForProduto(this.selectedProduct)
      if (excludeSignatureId != null) {
        return this.getFullPriceReferenceByType(targetType, excludeSignatureId, null)
      }
      return this.getFullPriceReferenceByType(targetType, null, periodoId)
    },
    isSignatureExpired (item) {
      const nextDate = this.signatureNextDate(item)
      if (!item || !nextDate) return false
      const expDay = this.parseNextDate(nextDate)
      if (!expDay) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      expDay.setHours(0, 0, 0, 0)
      return today > expDay
    },
    isSignatureRenewable (item) {
      if (!item || this.isSignatureWaitingPayment(item) || this.isSignatureEffectivelyActive(item)) return false
      return true
    },
    isSignatureWaitingPayment (item) {
      if (!item || this.isSignatureExpired(item)) return false
      return !item.active && (!item.nextDate || item.valid === 0)
    },
    isSignatureEffectivelyActive (item) {
      if (!item || this.isSignatureExpired(item)) return false
      return !!item.active
    },
    selectProduct (item) {
      const proceed = () => {
        this.product = item
        window.scrollTo(0, 0)
      }
      if (this.activeSignatures.length > 0) {
        this.product = null
        this.$dialog.confirm(this.secondSubscriptionConfirmMessage(item.id), {
          loader: true,
          okText: 'Continuar',
          cancelText: 'Cancelar'
        }).then(dialog => {
          proceed()
          dialog.close()
        }).catch(() => {})
      } else {
        proceed()
      }
    },
    gotoTelegram () {
      window.open('https://t.me/SuporteSwissMoney', '_blank')
    },
    async getData () {
      try {
        this.products = await getGrouped()
        if (!Array.isArray(this.products)) this.products = []
        this.signatures = await get()
        if (!Array.isArray(this.signatures)) this.signatures = []
        try {
          const params = await getSystemParameters()
          const days = Number(params && params.indicatorFullDiscountDays)
          if (!Number.isNaN(days) && days >= 0) this.indicatorFullDiscountDays = days
        } catch (paramError) {
          logger.error(paramError, this)
        }
      } catch (error) {
        logger.error(error, this)
      }
    },
    formatPrice (price) {
      if (price == null) return '0,00'
      return Number(price).toLocaleString('pt-br', { minimumFractionDigits: 2 })
    },
    formatPriceUsd (price) {
      if (price == null) return '0.00'
      return Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    platformLabel (platform) {
      const labels = {
        profit: 'Profit',
        blackarrow: 'BlackArrow',
        ninjatrader: 'NinjaTrader',
        tradingview: 'TradingView',
        dashboard: 'Dashboard',
        profit_yan: 'Profit Yan',
        blackarrow_yan: 'BlackArrow Yan',
        ninjatrader_yan: 'NinjaTrader Yan'
      }
      return labels[platform] || platform || ''
    },
    platformLogo (platform) {
      const logos = {
        profit: '/img/logo-profit.png',
        profit_yan: '/img/logo-profit.png',
        tradingview: '/img/logo-tv.png',
        ninjatrader: '/img/logo-nt.png',
        ninjatrader_yan: '/img/logo-nt.png',
        blackarrow: '/img/logo-ba.png',
        blackarrow_yan: '/img/logo-ba.png'
      }
      return logos[platform] || null
    },
    productTypeLabel (type) {
      if (type === 'bot') return 'Bot'
      if (type === 'dash') return 'Dash'
      return 'Indicador'
    },
    promotionPrice (per) {
      const price = Number(per.price) || 0
      const discount = Number(per.discount) || 0
      if (per.type === 'percent') return Math.max(0, price * (1 - discount / 100))
      if (per.type === 'fixed') return Math.max(0, price - discount)
      return price
    },
    promotionPriceUsd (per) {
      const priceUsd = Number(per.priceUsd) || 0
      const discount = Number(per.discount) || 0
      if (per.type === 'percent') return Math.max(0, priceUsd * (1 - discount / 100))
      if (per.type === 'fixed') return Math.max(0, priceUsd - discount)
      return priceUsd
    },
    periodPriceBrl (per) {
      if (!per) return 0
      if (per.promotion && (per.type === 'percent' || per.type === 'fixed')) {
        return Math.round(this.promotionPrice(per) * 100) / 100
      }
      return Math.round((Number(per.price) || 0) * 100) / 100
    },
    periodPriceUsd (per) {
      if (!per) return 0
      if (per.promotion && (per.type === 'percent' || per.type === 'fixed')) {
        return Math.round(this.promotionPriceUsd(per) * 100) / 100
      }
      return Math.round((Number(per.priceUsd) || 0) * 100) / 100
    },
    isSecondSubscription (periodoId) {
      if (!periodoId || !this.activeSignatures.length) return false
      return !this.activeSignatures.some(s => Number(s.product) === Number(periodoId))
    },
    shouldApplySecondSubscriptionDiscount (periodoId) {
      if (!this.isSecondSubscription(periodoId)) return false
      return this.isMainSubscriptionDiscountEligible(periodoId)
    },
    getSecondSubscriptionDiscount (per) {
      if (!per) return 0
      const v = per.secondSubscriptionDiscount != null
        ? per.secondSubscriptionDiscount
        : per.second_subscription_discount
      return Math.min(100, Math.max(0, parseInt(v, 10) || 0))
    },
    getDiscountPercentForItem (item) {
      if (item && item.renewalDiscountPercent != null && Number(item.renewalDiscountPercent) > 0) {
        return Number(item.renewalDiscountPercent)
      }
      const per = this.getSignaturePeriod(item)
      const fromPeriod = this.getSecondSubscriptionDiscount(per)
      if (fromPeriod > 0) return fromPeriod
      const prod = (this.products || []).find(p =>
        (p.periods || []).some(x => Number(x.id) === Number(item && item.product))
      )
      if (!prod) return 0
      return (prod.periods || []).reduce((max, x) => {
        const pct = this.getSecondSubscriptionDiscount(x)
        return pct > max ? pct : max
      }, 0)
    },
    applySecondSubscriptionDiscount (price, discountPercent) {
      const pct = Math.min(100, Math.max(0, Number(discountPercent) || 0))
      return Math.round(Number(price) * (1 - pct / 100) * 100) / 100
    },
    secondSubscriptionPriceBrl (per) {
      return this.applySecondSubscriptionDiscount(this.periodPriceBrl(per), this.getSecondSubscriptionDiscount(per))
    },
    secondSubscriptionPriceUsd (per) {
      return this.applySecondSubscriptionDiscount(this.periodPriceUsd(per), this.getSecondSubscriptionDiscount(per))
    },
    secondSubscriptionConfirmMessage (periodoId) {
      if (this.isSecondSubscription(periodoId)) {
        // const ref = this.getReferenceSignatureForSecondSubscription(periodoId)
        // const refDate = ref && ref.nextDate
        const per = this.selectedPeriod && Number(this.selectedPeriod.id) === Number(periodoId)
          ? this.selectedPeriod
          : this.findPeriodById(periodoId)
        const discount = this.shouldApplySecondSubscriptionDiscount(periodoId)
          ? this.getSecondSubscriptionDiscount(per)
          : 0
        const discountText = discount > 0
          ? ` Esta segunda assinatura terá ${discount}% de desconto e`
          : ' Esta segunda assinatura'
        return `Você já possui uma assinatura ativa.${discountText}. Deseja continuar?`
      }
      return 'Deseja adquirir também essa assinatura?'
    },
    findPeriodById (periodoId) {
      if (periodoId == null || periodoId === '') return null
      for (const prod of this.products || []) {
        const per = (prod.periods || []).find(p =>
          Number(p.id) === Number(periodoId) ||
          Number(p.periodoId) === Number(periodoId) ||
          Number(p.periodo_id) === Number(periodoId)
        )
        if (per) return per
      }
      return null
    },
    getSignaturePeriod (item) {
      if (!item || item.product == null) return null
      return this.findPeriodById(item.product)
    },
    getRenewalOriginalPriceBrl (item) {
      if (item && item.originalPrice != null && item.originalPrice !== '') {
        return Number(item.originalPrice)
      }
      const per = this.getSignaturePeriod(item)
      if (per) return this.periodPriceBrl(per)
      return Number(item.price) || 0
    },
    getRenewalPriceBrl (item) {
      if (item && item.renewalDiscountApplies && item.renewalPrice != null) {
        return Number(item.renewalPrice)
      }
      const base = this.getRenewalOriginalPriceBrl(item)
      if (!this.shouldApplyRenewalDiscount(item)) return base
      return this.applySecondSubscriptionDiscount(base, this.getDiscountPercentForItem(item))
    },
    buildCheckoutFromSignature (item) {
      const per = this.getSignaturePeriod(item)
      const useUsd = this.showUsd && per && per.priceUsd != null && per.priceUsd > 0
      const originalPrice = per
        ? (useUsd ? this.periodPriceUsd(per) : this.periodPriceBrl(per))
        : Number(item.price) || 0
      let price = originalPrice
      let secondSubscription = false
      let secondSubscriptionDiscount = 0
      let alignedNextDate = null
      const reference = this.getRenewalReferenceSignature(item)
      if (reference) {
        secondSubscription = true
        alignedNextDate = reference.nextDate
        if (this.shouldApplyRenewalDiscount(item)) {
          secondSubscriptionDiscount = this.getDiscountPercentForItem(item)
          price = this.applySecondSubscriptionDiscount(originalPrice, secondSubscriptionDiscount)
        }
      }
      return {
        name: item.name,
        id: item.product,
        productType: this.getProductTypeForSignature(item),
        price,
        originalPrice,
        secondSubscription,
        secondSubscriptionDiscount,
        alignedNextDate,
        desc: item.desc
      }
    },
    buildCheckoutProduct (per) {
      const useUsd = this.showUsd && per.priceUsd != null && per.priceUsd > 0
      const originalPrice = useUsd ? this.periodPriceUsd(per) : this.periodPriceBrl(per)
      let price = originalPrice
      let secondSubscription = false
      let secondSubscriptionDiscount = 0
      let alignedNextDate = null
      if (this.isSecondSubscription(per.id)) {
        secondSubscription = true
        const reference = this.getReferenceSignatureForSecondSubscription(per.id)
        alignedNextDate = reference ? reference.nextDate : null
        if (this.shouldApplySecondSubscriptionDiscount(per.id)) {
          secondSubscriptionDiscount = this.getSecondSubscriptionDiscount(per)
          price = this.applySecondSubscriptionDiscount(originalPrice, secondSubscriptionDiscount)
        }
      }
      const name = (this.platformLabel(this.selectedProduct.platform) || this.selectedProduct.name) + ' - ' + (per.periodName || per.period_name)
      return {
        name,
        id: per.id,
        productType: this.getProductTypeForProduto(this.selectedProduct),
        price,
        originalPrice,
        secondSubscription,
        secondSubscriptionDiscount,
        alignedNextDate
      }
    },
    confirmarAssinatura () {
      if (!this.selectedProduct || !this.selectedPeriod) return
      if (!this.canPurchaseSelectedProduct) {
        this.showIndicatorRequirementError()
        return
      }
      const per = this.selectedPeriod
      const proceed = () => {
        this.product = this.buildCheckoutProduct(per)
        this.signId = null
        this.selectedWaiting = true
        window.scrollTo(0, 0)
      }
      if (this.activeSignatures.length > 0) {
        this.$dialog.confirm(this.secondSubscriptionConfirmMessage(per.id), {
          loader: true,
          okText: 'Continuar',
          cancelText: 'Cancelar'
        }).then(dialog => {
          proceed()
          dialog.close()
        }).catch(() => {})
      } else {
        proceed()
      }
    },
    async callPayment (item) {
      if (
        (item && this.signatureRequiresIndicator(item) && !this.hasActiveIndicatorSubscription) ||
        (!item && this.product && this.productTypeRequiresIndicator(this.product.productType) && !this.hasActiveIndicatorSubscription)
      ) {
        this.showIndicatorRequirementError()
        return
      }
      this.selectedWaiting = true
      if (item) {
        this.signId = item.id
        this.product = this.buildCheckoutFromSignature(item)
      } else {
        this.signId = null
      }
    },
    async callPix (item) {
      // Parameters and options
      /* let message = 'Deseja gerar um PIX para pagar essa assinatura?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continuar',
        cancelText: 'Cancelar',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard', basic
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 0, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      } */

      this.$dialog.confirm('Deseja gerar um PIX para pagar essa assinatura?', {
        loader: true, // default: false - when set to true, the proceed button shows a loader when clicked.
        // And a dialog object will be passed to the then() callback
        okText: 'Continuar',
        cancelText: 'Cancelar'
      }).then(async dialog => {
        // Triggered when proceed button is clicked
        // dialog.loading(false) // stops the proceed button's loader
        // dialog.loading(true) // starts the proceed button's loader again
        // dialog.close() // stops the loader and close the dialog
        // do some stuff like ajax request.
        // console.log('Delete action completed ')
        try {
          // if (this.loading) return false
          this.loading = true
          this.error = []
          if (item) {
            this.product = {
              name: item.name,
              id: item.product,
              price: item.price
            }
            this.signId = item.id
          } else {
            this.signId = null
          }
          const resultPix = await payment(this.signId, this.product.name, this.product.id, this.product.price)
          dialog.close()
          this.selectedWaiting = {
            printUrl: resultPix
          }
          this.product = null
          this.signatures = await get()
          this.$analytics.event('bought', this.product.id)
          this.loading = false
        } catch (error) {
          dialog.close()
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = data.fields
          } else if (data.error) {
            this.error = [data.error]
          } else {
            logger.error(error, this)
          }
          this.loading = false
        }
      }).catch(() => {
        // Triggered when cancel button is clicked
        // console.log('Delete aborted')
      })
      // Trigger a confirmation dialog
      /* this.$dialog.confirm(message, options)
      .then(async function () {
        // This will be triggered when user clicks on proceed
        console.log('ok')
        try {
          // if (this.loading) return false
          this.loading = true
          this.error = []
          if (item) {
            this.product = {
              name: item.name,
              id: item.product,
              price: item.price
            }
          }
          const resultPix = await payment(this.product.name, this.product.id, this.product.price)
          this.selectedWaiting = {
            printUrl: resultPix
          }
          this.product = null
          this.signatures = await get()
          this.$analytics.event('bought', this.product.id)
          this.loading = false
        } catch (error) {
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = data.fields
          } else if (data.error) {
            this.error = [data.error]
          } else {
            logger.error(error, this)
          }
          this.loading = false
        }
      })
      .catch(function () {
        // This will be triggered when user clicks on cancel
        // console.log('nok')
      }) */

      /* if (confirm('Deseja gerar um PIX para pagar essa assinatura?')) {
      } */
    },
    async finishPlan () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        await create(this.product.id, this.product.price)
        this.product = null
        this.getData()
        this.loading = false
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import "../_asset/scss/_variables";
// Tema escuro para vuejs-dialog (confirm modals)
.dg-main-content {
  background-color: #161b22 !important;
  border: 2px solid #333;
}
.dg-content {
  text-align: center;
  color: #ccc !important;
}
.dg-content-body {
  border-bottom-color: #333 !important;
}
.dg-btn--cancel {
  background-color: $primary-color !important;
  color: #fff !important;
  border-color: $primary-color !important;
}
.dg-btn--ok {
  border-color: $primary-color !important;
  color: $primary-color !important;
  background-color: transparent !important;
}

.dg-btn-loader .dg-circle {
  background-color: $primary-color;
}
.hint {
    font-size: 12px;
    color: $error-color;
    margin-top: 3px;
  }
.button-save {
  margin-top: 20px;
    color: #fff;
    border: none;
    border-radius: 100px;
    box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    font-size: 1em;
    font-weight: 400;
    width: auto;
    height: 40px;
    padding: 0 15px;
    cursor: pointer;
    &:focus {
      outline: 0;
    }
    i {
      margin-right: 7px;
    }
  }

.section {
  margin-top: $menu-height;
  margin: 0px;
  padding: 0px;
}

.assinatura-page {
  padding-top: 50px;
  padding-bottom: 50px;
}

.content-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.my-subscriptions-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 20px 40px;
}
.my-subscriptions-title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin: 0 0 40px 0;
}
.my-subscription-card {
  margin-bottom: 30px;
}
.subscription-info {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  align-items: stretch;
}
.subscription-plan-card {
  background: #161b22;
  border: 2px solid #333;
  border-radius: 12px;
  padding: 24px 28px;
  min-width: 260px;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.subscription-plan-name {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 12px 0;
}
.subscription-plan-desc {
  font-size: 14px;
  color: #ccc;
  margin: 0 0 8px 0;
  line-height: 1.4;
}
.subscription-plan-price {
  font-size: 22px;
  font-weight: 700;
  color: #8d6ef4;
  margin: 12px 0 16px 0;

  .price-original {
    text-decoration: line-through;
    color: #888;
    font-size: 16px;
    margin-right: 8px;
    font-weight: 400;
  }
}
.subscription-notice {
  margin: 0 0 12px 0;
  font-size: 0.8em;
}
.renewal-discount-hint {
  font-size: 13px;
  color: #c4b5fd;
  margin-bottom: 16px;
  line-height: 1.4;
  text-align: center;
}
.subscription-badge {
  margin-top: auto;
  padding: 12px 16px;
  background: linear-gradient(to bottom right, $primary-color, $secondary-color);
  color: #000;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  border-radius: 8px;
}
.subscription-status-card {
  background: #161b22;
  border: 2px solid #333;
  border-radius: 12px;
  padding: 28px 32px;
  min-width: 300px;
  max-width: 420px;
  display: flex;
  flex-direction: column;
}
.status-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.status-label {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
.status-waiting .status-label,
.status-expired .status-label {
  color: #ff6b6b;
}
.status-active .status-label {
  color: #4ade80;
}
.status-detail {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  color: #ccc;
}
.status-detail-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #888;
  margin-bottom: 4px;
}
.status-detail-value {
  font-size: 16px;
  color: #fff;
}
.btn-payment {
  margin: 8px 0 !important;
  padding: 14px 24px !important;
  font-size: 15px !important;
}
.subscription-contact {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #333;
  text-align: center;
}
.contact-text {
  font-size: 12px;
  color: #888;
  margin: 0 0 12px 0;
}
.telegram-icon {
  height: 48px;
  cursor: pointer;
  opacity: 0.9;
  transition: opacity 0.2s;
}
.telegram-icon:hover {
  opacity: 1;
}
@media (max-width: 768px) {
  .subscription-info {
    flex-direction: column;
    align-items: center;
  }
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.finish_plan {
  text-align: center;
  width: 400px;
  height: 300px;
  margin: 5px;
  margin-left: 20px;
  //border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  .btn-buyplan {
    text-align: center;
    font-size: 0.7em;
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    border-radius: 5px 5px;
    object-fit: cover;
    width: 400px;
    flex: none;
    margin-top: 40px;
  }
}
.show_plan {
  text-align: center;
  width: 200px;
  height: 300px;
  margin: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.2);
    transform: scale(1.02);
  }
  .btn-buy {
    text-align: center;
    font-size: 0.7em;
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    border-radius: 0 0 5px 5px;
    object-fit: cover;
    width: 200px;
    flex: none;
  }
}
.card_event {
  min-height: 155px;
  flex: 1;
}
.show-name {
  color: #202020;
  font-size: 20px;
}
.show-date {
  font-size: 14px;
  font-weight: 300;
  color: #202020;
  margin: 2px 10px;
  padding: 0px 10px;
}
.plan_discount {
  text-decoration: line-through;
  font-size: 14px;
  color: #e92a2a;
}
.list_plans {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  align-content: stretch;
}
.main-text {
  margin-top: 60px;
  padding: 20px;
  color: #202020;
  font-size: 30px;
  text-align: center;
  font-family:'Arial';
  width: 95%;
}

.plans-section-assinatura {
  background: #0b0e11;
  padding: 50px 20px 80px;
  margin-top: 24px;
  width: 100vw;
  margin-left: calc(50% - 50vw);
  box-sizing: border-box;
  border-radius: 0;
  position: relative;
  z-index: 2;

  .plans-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .plans-title {
    margin-top: 0;
    color: #fff;
    font-size: 30px;
    text-align: center;
    padding: 20px;
    font-family: 'Arial', sans-serif;
  }
}

// Plans Section (igual Main.vue)
.plans-platform-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 30px;
  margin-bottom: 24px;
  position: relative;
  z-index: 3;
}

.platform-tab {
  width: 180px;
  min-width: 180px;
  padding: 12px 16px;
  background: #161b22;
  border: 2px solid #333;
  border-radius: 10px;
  color: #ccc;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s;
  text-align: center;
  position: relative;
  z-index: 1;
  pointer-events: auto;

  &:hover {
    border-color: #5134f5;
    color: #fff;
  }

  &.active {
    border-color: #5134f5;
    background: linear-gradient(135deg, rgba(81, 52, 245, 0.2), rgba(141, 110, 244, 0.2));
    color: #fff;
  }
}

.plans-content {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 32px;
  margin-top: 20px;
  align-items: start;
}

.plans-periods {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.period-item {
  padding: 16px 20px;
  background: #161b22;
  border: 2px solid #333;
  border-radius: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.25s;

  &:hover {
    border-color: #5134f5;
  }

  &.active {
    border-color: #5134f5;
    background: linear-gradient(135deg, rgba(81, 52, 245, 0.15), rgba(141, 110, 244, 0.15));
  }
}

.period-item-name {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.period-item-prices {
  font-size: 14px;
  color: #ccc;

  .period-price-old {
    text-decoration: line-through;
    margin-right: 8px;
    color: #888;
  }
  .period-price-promo {
    color: #8d6ef4;
    font-weight: 600;
  }
  .period-price {
    color: #fff;
  }
  .period-usd {
    margin-left: 12px;
  }
}

.period-item-validity {
  font-size: 12px;
  color: #8d6ef4;
  margin-top: 6px;
}

.period-item-second-sub {
  font-size: 12px;
  color: #c4b5fd;
  margin-top: 6px;
  line-height: 1.4;
}

.plans-detail {
  min-height: 280px;
}

.plan-detail-card {
  background: #161b22;
  border: 2px solid #333;
  border-radius: 15px;
  padding: 32px 36px;
  text-align: left;
}

.plan-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 8px;
}

.plan-detail-platform {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.plan-detail-logo {
  width: 120px;
  height: auto;
  max-height: 40px;
  object-fit: contain;
  flex-shrink: 0;
}

.plan-detail-period {
  font-size: 16px;
  color: #8d6ef4;
  margin: 0 0 16px 0;
}

.plan-detail-desc {
  font-size: 14px;
  color: #ccc;
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.plan-detail-price {
  margin-bottom: 12px;

  .price-original {
    text-decoration: line-through;
    font-size: 16px;
    color: #888;
    margin-right: 10px;
  }
  .price-amount {
    font-size: 28px;
    font-weight: 700;
    color: #8d6ef4;
  }
}

.plan-detail-validity {
  font-size: 14px;
  color: #ffc107;
  margin: 0 0 20px 0;
}

.second-sub-notice {
  margin: 12px 0;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(81, 52, 245, 0.15);
  border: 1px solid rgba(141, 110, 244, 0.45);
  font-size: 0.85em;
  line-height: 1.45;
  color: #e8e0ff;

  strong {
    display: block;
    margin-bottom: 4px;
    color: #fff;
  }

  span {
    display: block;
  }

  &.plan-detail-notice {
    margin-top: 0;
    margin-bottom: 14px;
  }
}

.indicator-required-notice {
  background: rgba(240, 91, 91, 0.12);
  border-color: rgba(240, 91, 91, 0.5);
  color: #ffd7d7;
}

.plan-detail-second-price {
  font-size: 14px;
  color: #c4b5fd;
  margin: 0 0 12px 0;

  strong {
    color: #fff;
  }
}

.plan-detail-features {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;

  li {
    padding: 6px 0;
    color: #ccc;
    font-size: 14px;
  }
}

.plan-button {
  width: 100%;
  padding: 15px;
  background: linear-gradient(to bottom right, #5134f5, #8d6ef4);
  color: #000;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
    transform: none;
  }
}

.plan-detail-button {
  width: 100%;
  padding: 16px;
  font-size: 16px;
}

.plan-detail-empty {
  background: #161b22;
  border: 2px dashed #333;
  border-radius: 15px;
  padding: 48px;
  text-align: center;
  color: #666;
}

@media (max-width: 768px) {
  .plans-content {
    grid-template-columns: 1fr;
  }
}
</style>
